import React from "react";
import { Link } from "react-router-dom";
import "../css/main.scss";
import productData from "../Datas/productData";

function Main() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="main">
      <main>
        <section className="hero-banner">
          <div className="banner-content">
            <h1>JEWELLERY WITH A SENSE OF PLACE</h1>
            <p>ORIGINAL DETAILS, NATURAL MATERIALS</p>
            <button className="banner-btn">DISCOVER THE COLLECTION</button>
          </div>
          <div className="banner-image">
            <img src="/main/main1.webp" alt="Hound and Home jewellery collection" />
          </div>
        </section>

        <section className="collections">
          <h2 className="section-title">The Perfect Piece for any Occasion</h2>
          <div className="collections-grid">
            <div className="collection-card">
              <img src="/main/main2-1.webp" alt="Gold Jewellery" />
              <h3>Gold Jewellery</h3>
              <p>
                Warm gold-finished details bring depth to sterling silver forms.
                Each product page identifies the materials and finish used for
                that individual design.
              </p>
            </div>
            <div className="collection-card">
              <img src="/main/main2-2.webp" alt="Handmade Rings" />
              <h3>Handmade Rings</h3>
              <p>
                Sculptural rings pair clean metalwork with stones selected for
                their individual colour and pattern. Natural variations make
                every piece subtly personal.
              </p>
            </div>
            <div className="collection-card">
              <img src="/main/main2-3.webp" alt="Heart Necklaces" />
              <h3>Heart Necklaces</h3>
              <p>
                Thoughtful pendants made for daily wear, gifting and meaningful
                moments. Simple silhouettes let polished metal and natural
                materials take the lead.
              </p>
            </div>
          </div>
        </section>

        <section className="featured-collection">
          <div className="featured-left">
            <img src="/main/main3-1.webp" alt="Malachite Collection" />
          </div>
          <div className="featured-right">
            <span className="collection-label">INTRODUCING</span>
            <h2>Malachite Collection</h2>
            <p>
              From delicate classics ideal for everyday wear to chic,
              trendsetting pieces that suit any occasion, our collection
              combines exquisite craftsmanship with a modern touch.
            </p>
          </div>
        </section>

        <section className="products-grid">
          <div className="products-container">
            {productData.slice(0, 4).map((product) => (
              <Link
                to={`/shopDetails/${product.id}`}
                key={product.id}
                className="product-card"
                onClick={toTop}
              >
                <div className="product-image">
                  <img src={product.image} alt={product.name} />
                </div>
                <div className="product-info">
                  <h4>{product.name}</h4>
                  <p className="price">£{product.price}</p>
                </div>
              </Link>
            ))}
          </div>
        </section>

        <section className="about-section">
          <div className="about-container">
            <h2 className="about-title">About Hound &amp; Home Jewellery</h2>
            <p className="about-subtitle">
              We understand that every piece of Hound &amp; Home jewellery in our
              collection represents a special moment in time, a memory or a
              passion.
            </p>
            <div className="about-grid">
              <div className="about-card">
                <img src="/main/main6-1.webp" alt="Proud to be Different" />
                <div className="about-card-content">
                  <h3>Proud to be Different</h3>
                  <p>
                    Hound &amp; Home creates considered jewellery that balances
                    organic forms with easy, everyday wear. Stones are selected
                    for character, then paired with clean settings and tactile
                    details.
                  </p>
                  <button className="about-btn">LEARN MORE</button>
                </div>
              </div>
              <div className="about-card">
                <img src="/main/main6-2.webp" alt="How it all Began" />
                <div className="about-card-content">
                  <h3>How it all Began</h3>
                  <p>
                    The name Hound &amp; Home brings together two ideas we value:
                    curiosity beyond the doorstep and the comfort of returning
                    home. That balance guides a collection made to travel with
                    you and become part of daily life.
                  </p>
                  <button className="about-btn">LEARN MORE</button>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="most-loved">
          <div className="most-loved-container">
            <h2 className="most-loved-title">
              Our most loved pieces right now
            </h2>
            <div className="most-loved-grid">
              {productData.slice(4, 8).map((product) => (
                <Link
                  to={`/shopDetails/${product.id}`}
                  key={product.id}
                  className="most-loved-card"
                  onClick={toTop}
                >
                  <div className="most-loved-image">
                    <img src={product.image} alt={product.name} />
                  </div>
                </Link>
              ))}
            </div>
            <div className="features-section">
              <div className="feature-item">
                <svg
                  className="feature-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                </svg>
                <h3>Made with Love</h3>
                <p>Handcrafted affordable gemstone jewellery</p>
              </div>
              <div className="feature-item">
                <svg
                  className="feature-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <rect x="1" y="3" width="15" height="13" />
                  <polygon points="16 8 20 8 23 11 23 16 16 16 16 8" />
                  <circle cx="5.5" cy="18.5" r="2.5" />
                  <circle cx="18.5" cy="18.5" r="2.5" />
                </svg>
                <h3>Fast UK Shipping</h3>
                <p>Tracked delivery options shown at checkout</p>
              </div>
              <div className="feature-item">
                <svg
                  className="feature-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                  <circle cx="12" cy="7" r="4" />
                  <path d="M12 12v8" />
                  <path d="M9 15h6" />
                </svg>
                <h3>Here When You Need Us</h3>
                <p>Product and order help at packs@houndandhome.xyz</p>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}

export default Main;
